import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid } from 'react-bootstrap';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import ChannelTitle from 'components/atoms/layout/ChannelTitle';
import { LoadingTile } from 'components/molecules/ErrorTile';
import { fetchMeta as fetchEntityMeta } from 'services/entities/duck';
import { shouldPromptUserFeedback } from 'services/feedback/duck';
import { LAYERTHREE, LAYERTWO } from '../../constants/layers';


class DetermineLayerContainer extends Component {
    constructor() {
        super();
        this.state = { entityId: null };
    }

    static getDerivedStateFromProps(props, state) {
        const entityId = parseInt(props.match.params.entityId, 10);

        if (entityId !== state.entityId) {
            return {
                ...state,
                entityId
            };
        }

        return null;
    }

    componentDidMount() {
        this.makeRequestsForData();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.entityId !== this.state.entityId) {
            this.makeRequestsForData();
        }
    }

    makeRequestsForData() {
        const entityId = this.state.entityId;
        const payload = this.createPayload(entityId);

        this.props.shouldPromptUserFeedback(payload);

        // Only trigger an API call if the data has not been previously pulled
        if (!this.props.entityMeta || this.props.entityMeta.id !== entityId) {
            this.props.fetchEntityMeta(payload);
        }
    }

    createPayload(entityId) {
        return {
            transactionId: `entity-${entityId}-determine-layer`,
            entityId
        };
    }

    render() {
        const hasEntityMeta = this.props.entityMeta.id;
        const aliasDefault = { layer: LAYERTHREE };
        const alias = get(this.props, 'entityMeta.brandAlias', aliasDefault) || aliasDefault;

        if (hasEntityMeta) {
            return alias.layer === LAYERTWO
                ? (<this.props.layerTwo {...this.props} layer={LAYERTWO} />)
                : (<this.props.layerThree {...this.props} layer={LAYERTHREE} />);
        }

        return (
            <Grid fluid={true}>
                <ChannelTitle />
                <LoadingTile />
            </Grid>
        );
    }
}

DetermineLayerContainer.propTypes = {
    layerThree: PropTypes.func.isRequired,
    layerTwo: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
    entityMeta: state.entities.meta
});

export default connect(mapStateToProps, {
    fetchEntityMeta,
    shouldPromptUserFeedback,
})(DetermineLayerContainer);



// WEBPACK FOOTER //
// ./src/containers/dashboards/DetermineLayerContainer.js